module.exports = {
  "zones": {
    "Pacific/Galapagos": ["z", {
      "wallclock": 504921600000,
      "format": "-06/-05",
      "abbrev": "-06",
      "offset": -21600000,
      "posix": 504939600000,
      "save": 0,
      "rules": "Ecuador"
    }, {
      "wallclock": -1230768000000,
      "format": "-05",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -1230746496000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -21504000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Ecuador": [{
      "from": 1993,
      "to": 1993,
      "month": 1,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1992,
      "to": 1992,
      "month": 10,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};